import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchNextsteps } from 'application/actions/nextstepsActions'
import { httpVerbConstants } from 'application/constants/actionTypes'

const useNextSteps = () => {
  const [proposalCompleted, handleNextSteps] = useState(false)
  const dispatch = useDispatch()
  const { opportunityId } = useSelector((state) => state.authentication)
  const { accessToken } = useSelector((state) => state.auth)
  const { hasProposal, hasSubmittedEstimate, hasProposalAccepted } =
    useSelector((state) => state.applicationRoles)
  const { state } = useSelector((state) => state.opportunity)
  const headers = { accessToken: accessToken }
  useEffect(() => {
    if (
      opportunityId &&
      hasProposal &&
      hasSubmittedEstimate &&
      hasProposalAccepted &&
      state &&
      state !== 'Lost' &&
      state !== 'Won'
    ) {
      handleNextSteps(true)
    }
  }, [
    hasProposal,
    hasSubmittedEstimate,
    hasProposalAccepted,
    state,
    opportunityId,
    dispatch,
  ])
  return {
    proposalCompleted: proposalCompleted,
    nextStepMethod: () =>
      dispatch(
        fetchNextsteps(opportunityId, headers, httpVerbConstants.HTTP_GET)
      ),
  }
}

export default useNextSteps
